// src/components/OcrModeExplainer.jsx
import React from "react";
import CREDIT_VALUE from "../utils/constants";

const OcrModeExplainer = ({ onClose }) => {
  return (
    <div className="modal modal-open">
      <div className="modal-box max-w-3xl">
        <h3 className="font-bold text-lg text-center">Choose Your OCR Mode</h3>
        <p className="py-2 text-center opacity-80">
          Each OCR mode processes your video slightly differently. Pick the one that best fits your needs.
        </p>

        <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4">
          {/* Cloud / AI */}
          <div className="card bg-base-200">
            <div className="card-body p-4">
              <div className="badge badge-secondary mb-2">Cloud AI</div>
              <div className="font-bold">{1 / CREDIT_VALUE.cloud} frame per credit</div>
              <ul className="list-disc ml-4 space-y-1 text-sm">
                <li>
                  <b>Best for:</b> Complex formatting, handwriting AI-enhanced detection.
                </li>
                <li>
                  <b>Speed:</b> Fastest; Most advanced.
                </li>
                <li>
                  <b>Why choose it:</b> Highest accuracy for tricky or messy text.
                </li>
                <li>
                  <b>Note:</b> Requires an internet connection; data is sent to the cloud.
                </li>
              </ul>
            </div>
          </div>

          {/* Balanced */}
          <div className="card bg-base-200">
            <div className="card-body p-4">
              <div className="badge badge-accent mb-2">Basic</div>
              <div className="font-bold">{1 / CREDIT_VALUE.server} frames per credit</div>
              <ul className="list-disc ml-4 space-y-1 text-sm">
                <li>
                  <b>Best for:</b> Consistently sized, white-on-black, printed text recognition.
                </li>
                <li>
                  <b>Speed:</b> Moderate.
                </li>
                <li>
                  <b>Why choose it:</b> Cheap for large jobs with very clear text.
                </li>
                <li>
                  <b>Note:</b> Faster but similar quality to local OCR.
                </li>
              </ul>
            </div>
          </div>

          {/* Local */}
          <div className="card bg-base-200">
            <div className="card-body p-4">
              <div className="badge badge-primary mb-2">Local</div>
              <div className="font-bold">{1 / CREDIT_VALUE.local} frames per credit</div>
              <ul className="list-disc ml-4 space-y-1 text-sm">
                <li>
                  <b>Best for:</b> Standard printed text, entire frame dump results.
                </li>
                <li>
                  <b>Speed:</b> Slowest; runs directly on your computer.
                </li>
                <li>
                  <b>Why choose it:</b> No cloud uploads, full offline control.
                </li>
                <li>
                  <b>Note:</b> May struggle with messy handwriting or unusual fonts.
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="modal-action">
          <button className="btn" onClick={onClose}>
            Got it!
          </button>
        </div>
      </div>
    </div>
  );
};

export default OcrModeExplainer;
